import React, { useEffect, useState, useRef } from "react";

import {
  SearchOutlined,
  EditOutlined,
  ReloadOutlined,
  CheckOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import {
  PageHeader,
  Pagination,
  Input,
  Button,
  Table,
  Spin,
  Typography,
  Tag,
  List,
  InputNumber,
  Tabs,
  Modal,
  Select,
  message,
} from "antd";

import moment from "moment";

import PackageTable from "../../components/packages/Table";
import PackageModal from "../../components/packages/packageModal";
import { numberWithCommas } from "../../utils/helpers";
import AddEditModal from "../../components/Generic/AddEditModal";
import ImageChecker from "../../components/Generic/ImageChecker";

import { getLocations } from "../../Redux/actions/locationsActions";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  loadMorePackageData,
  approvePackage,
  mergePackage,
  backtoPendingPackage,
  completeDirectPackageManual,
} from "../../Redux/actions/packageActions";
import "./styles.scss";
import "./styles.css";

import PrintPackageLabel from "../../components/packages/PrintPackageLabel";
import PrintPackageOrderList from "../../components/packages/PrintPackageOrderList";

import ShipPackage from "../../components/packages/ShipPackage";

import PackageQRScanner from "../../components/packages/PackageQRScanner";
import PackageSummary from "../../components/packages/packageSummary";

const { Option } = Select;

const { TabPane } = Tabs;
const { Search } = Input;
const INITIAL_STATE = {
  searchText: "",
};
const API_URL = "packages";

const PAGENAME = "Package";

const MODAL_BLUEPRINT = [
  {
    title: "Name",
    key: "name",
    type: "text",
  },
  {
    title: "Address",
    key: "address",
    type: "text",
  },
  {
    title: "phone",
    key: "contactno",
    type: "number",
  },
  {
    title: "contact person",
    key: "contact_person",
    type: "text",
  },
  {
    title: "operating hours",
    key: "operating_hours",
    type: "text",
  },
];

const Index = (props) => {
  const [loading, setloading] = useState(false);
  const [mainSearch, setMainSearch] = useState(null);
  const [resetTable, setResetTable] = useState(false);

  const [modalMode, setModalMode] = useState("edit");
  const [currentSelected, setCurrentSelected] = useState([]);
  const [currentSelectedRow, setCurrentSelectedRow] = useState(null);

  const [packageStatus, setPackageStatus] = useState("toPack");
  const [mergeto, setMergeto] = useState(null);
  const [mergetoPackage, setMergetoPackage] = useState(null);

  const tableRef = useRef();
  const dispatch = useDispatch();
  const { crudData, crudDataCount, locations, user } = useSelector(
    (state) => ({
      user: state.auth.user,
      crudData: state.packages.data,
      crudDataCount: state.packages.dataCount,
      locations: state.locations.locations,
    }),
    shallowEqual
  );
  useEffect(() => {
    dispatch(getLocations());
  }, []);

  const onSearch = (value) => {
    setMainSearch(value);
  };

  const itemSelected = (value) => {
    setCurrentSelected(value);
  };

  const rowIsSelected = (value) => {
    setCurrentSelectedRow(value);
  };

  const mergeButton = (record) => {
    if (record && crudData) {
      var samedestination = [];
      crudData.map((package_thing) => {
        if (
          record.id != package_thing.id &&
          record.destination == package_thing.destination
        ) {
          samedestination.push(package_thing);
        }
      });
      var mergedata = {
        options: samedestination,
        current: record,
      };

      return (
        <div>
          <Button
            type="link"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setMergeto(mergedata);
            }}
          >
            merge
          </Button>
        </div>
      );
    }
  };

  const mergePackages = () => {
    if (mergeto && mergetoPackage) {
      setloading(true);
      var keepPackage = null;
      mergeto.options.map((it) => {
        if (mergetoPackage == it.id) {
          keepPackage = it;
        }
      });
      if (keepPackage && mergeto.current) {
        dispatch(mergePackage(mergeto.current, keepPackage))
          .then((res) => {
            message.success("packages merged");
            setResetTable(!resetTable);
            setMergeto(null);
            setMergetoPackage(null);
            setloading(false);
          })
          .catch((err) => {
            message.error("packages not merged");
            setMergeto(null);
            setMergetoPackage(null);
            setloading(false);
          });
      }
    }
  };

  const summarycopy = (record) => {
    var copystring = "```" + "\r\n";
    copystring =
      copystring +
      `Good day, here are the list of item are missing, May we request for it to be replaced or refunded, Thank you!` +
      "\r\n";
    copystring =
      copystring + `${moment().add(1, "days").format("dddd, LL")} ` + "\r\n";
    copystring = copystring + `branch: ${record.destination_name} ` + "\r\n";
    copystring = copystring + `____________________` + "\r\n" + "\r\n";
    var costTotal = 0;
    record.items.map((xitem) => {
      if (xitem.quantity_discrepancy > 0) {
        costTotal =
          costTotal +
          parseFloat(xitem.cost_peso) * parseFloat(xitem.quantity_discrepancy);
        copystring =
          copystring +
          `► ${xitem.product_name} - missing: ${xitem.quantity_discrepancy} ${
            xitem.unit
          }${xitem.tobuy > 1 ? "s" : ""}  (${(
            parseFloat(xitem.cost_peso) * parseFloat(xitem.quantity_discrepancy)
          ).toFixed(2)})` +
          "\r\n";
        copystring =
          copystring +
          `  - ordered: ${xitem.ordered_quantity} ${xitem.unit}${
            xitem.tobuy > 1 ? "s" : ""
          } ` +
          "\r\n";
        copystring =
          copystring +
          `  - recieved: ${xitem.received_quantity} ${xitem.unit}${
            xitem.tobuy > 1 ? "s" : ""
          } ` +
          "\r\n";
      }
    });

    copystring = copystring + `____________________` + "\r\n" + "\r\n";

    copystring = copystring + `Overall value: ` + "\r\n";
    copystring = copystring + `${costTotal.toFixed(2)}` + "\r\n";
    copystring = copystring + "```";
    navigator.clipboard.writeText(copystring);
    message.success("message copied to clipboard");
  };

  const actionsRender = (record) => {
    const approve = () => {
      dispatch(approvePackage(record, record.id))
        .then((res) => {
          setResetTable(!resetTable);
        })
        .catch((err) => {
          setResetTable(!resetTable);
        });
    };

    const backtopending = () => {
      dispatch(backtoPendingPackage(record.id))
        .then((res) => {
          setResetTable(!resetTable);
        })
        .catch((err) => {
          setResetTable(!resetTable);
        });
    };

    if (record) {
      var newrec = {
        ...record,
      };
      var dest = locations.filter((i) => i.id == record.destination);
      var destData = dest[0];
      var hasdiscrepancy = false;
      if (destData) {
        newrec["dest"] = destData;
      }
      var new_quantity_to_approve = false;
      record.items.map((item) => {
        if (item?.new_quantity_to_approve) {
          if (item.new_quantity_to_approve == true) {
            new_quantity_to_approve = true;
          }
        }
        if (item?.quantity_discrepancy > 0) {
          hasdiscrepancy = true;
        }
      });
      // console.log(record);
      return (
        <div>
          {/* <Button
            onClick={() => {
              dispatch(completeDirectPackageManual(record));
            }}
          >
            Manual Complete
          </Button> */}
          {(user.role == "admin" ||
            user.role == "warehouse" ||
            user.role == "manager") &&
          record.status == "toShip" ? (
            <ShipPackage
              currentItem={newrec}
              onCloseModal={() => {
                setResetTable(!resetTable);
              }}
            />
          ) : null}
          {(user.role == "admin" ||
            user.role == "warehouse" ||
            user.role == "manager") &&
          record.status !== "cancelled" &&
          record.status !== "pending" ? (
            <PrintPackageLabel currentItem={record} />
          ) : null}
          {(user.role == "admin" ||
            user.role == "warehouse" ||
            user.role == "manager") &&
          record.status !== "pending" ? (
            <PrintPackageOrderList currentItem={record} />
          ) : null}
          {(user.role == "admin" || user.role == "manager") &&
          record.status == "toPack" ? (
            <Button
              type="dashed"
              onClick={() => {
                backtopending();
              }}
            >
              Back To Pending
            </Button>
          ) : null}

          {user.role == "admin" && record.status == "pending" ? (
            new_quantity_to_approve ? (
              <Button
                type
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  rowIsSelected(record);
                }}
              >
                Approve Quantity Changes
              </Button>
            ) : (
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  approve();
                }}
              >
                Approve
              </Button>
            )
          ) : null}

          {packageStatus == "pending" &&
          (user.role !== "oic" || user.role == "manager")
            ? mergeButton(record)
            : null}

          {record?.is_direct &&
          hasdiscrepancy &&
          packageStatus == "completed" ? (
            <Button
              type="link"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                summarycopy(record);
              }}
            >
              Copy To Clipboard
            </Button>
          ) : null}
        </div>
      );
    }
  };

  const createDestinationFilter = () => {
    if (user) {
      var locationsfiltered = [
        {
          text: user.branch_name,
          value: user.branch_name,
        },
      ];
    }

    if (
      user.role == "warehouse" ||
      user.role == "admin" ||
      user.role == "manager"
    ) {
      locationsfiltered = locations.map((item) => {
        var newloc = {
          text: item.name,
          value: item.name,
        };
        return newloc;
      });
    }

    return locationsfiltered;
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id.localeCompare(b.id),
      render: (text, record, index) => {
        return (
          <div className="vertical">
            <span> {text} </span>
            <div> {actionsRender(record)}</div>
          </div>
        );
      },
    },
    {
      title: "Destination",
      dataIndex: "destination_name",
      key: "destination_name",
      filters: createDestinationFilter(),
      onFilter: (value, record) => value.includes(record.destination_name),
      sorter: (a, b) => a.destination_name.localeCompare(b.destination_name),
      render: (text, record, index) => {
        return (
          <div className="vertical">
            <h4> {text} </h4>
            {record.is_direct ? (
              <Tag color="blue"> DIRECT SHIPPING</Tag>
            ) : (
              <Tag color="green"> HQ</Tag>
            )}
          </div>
        );
      },
    },
    {
      title: "Created",
      dataIndex: "created_at",
      key: "created_at",
      sorter: (a, b) => a.created_at.localeCompare(b.created_at),
      render: (text, record, index) => {
        return (
          <div className="vertical">
            <span> {moment(text).format("LLL")} </span>
            <span> {record.created_name}</span>
          </div>
        );
      },
    },
    {
      title: "Destination",
      render: (text, record, index) => {
        var dest = locations.filter((i) => i.id == record.destination);
        var destData = dest[0];
        if (destData) {
          return (
            <div className="vertical">
              <span> {destData.contact_person} </span>
              <span> {destData.contactno}</span>
              <span> {destData.address}</span>
            </div>
          );
        }
      },
    },

    {
      title: "Items",

      render: (text, record, index) => {
        var sorteditems = record.items.sort((a, b) => {
          if (a?.new_quantity_to_approve && b?.new_quantity_to_approve) {
            if (a.new_quantity_to_approve && !b.new_quantity_to_approve) {
              return -1;
            }
            if (!a.new_quantity_to_approve && b.new_quantity_to_approve) {
              return 1;
            }
          }
          if (a?.new_quantity_to_approve && !b?.new_quantity_to_approve) {
            return -1;
          }
          if (!a?.new_quantity_to_approve && b?.new_quantity_to_approve) {
            return 1;
          }
          return 0;
        });
        return (
          <>
            <List
              className="Itemlist"
              itemLayout="horizontal"
              dataSource={sorteditems}
              size={"small"}
              renderItem={(item) => {
                var turnyellow = false;
                var defaultval = item.quantity;
                if (item?.new_quantity_to_approve) {
                  if (item.new_quantity_to_approve == true) {
                    turnyellow = true;
                    defaultval = item.new_quantity;
                  }
                }
                var classnamestring = "";
                if (turnyellow) {
                  classnamestring = "yellowbg";
                }
                if (record.status == "toPack" || record.status == "pending") {
                  if (
                    parseFloat(item.quantity) >
                    parseFloat(item.location_available)
                  ) {
                    if (user.branch !== record.destination) {
                      if (
                        user.role == "warehouse" ||
                        user.role == "manager" ||
                        user.role == "admin"
                      ) {
                        classnamestring = `kulangrow ${
                          item.regionalization == "international"
                            ? "imported_kulang"
                            : ""
                        }  `;
                      }
                    }
                  }
                }

                if (item?.quantity_discrepancy > 0) {
                  classnamestring = "discrepancy";
                }

                return (
                  <List.Item
                    // actions={[
                    //   <Button type='link' onClick={()=>{deleteThis(item.id)}}>
                    //     <DeleteOutlined  />
                    //   </Button>
                    // ]}
                    className={classnamestring}
                  >
                    <List.Item.Meta
                      avatar={
                        <ImageChecker
                          url={`${process.env.REACT_APP_AWS_S3}${item.product}.png`}
                          success={
                            <img
                              src={`${process.env.REACT_APP_AWS_S3}${item.product}.png`}
                              alt="image"
                              className={"prodimage"}
                            />
                          }
                          fail={
                            <img
                              src={`${process.env.REACT_APP_AWS_S3}logo.jpg`}
                              alt="image"
                              className={"prodimage"}
                            />
                          }
                        />
                      }
                      title={<span className="name">{item.product_name}</span>}
                      description={
                        <div className="horizontalItem">
                          <div className="verticalItem">
                            <h1> x{defaultval} </h1>
                            {turnyellow ? (
                              <div className="tinyText bluegrey">{`old qty: ${parseFloat(
                                item.quantity
                              ).toFixed(2)}`}</div>
                            ) : null}
                            <label className="tinyText">{item.unit}</label>
                          </div>
                          <div className="available_container">
                            {user.role == "admin" ||
                            user.role == "warehouse" ||
                            user.role == "manager" ? (
                              <div className="tinyText bluegrey">{`left there: ${parseFloat(
                                item.destination_available
                              ).toFixed(2)}`}</div>
                            ) : null}
                            <div className="tinyText redgrey">{`left here: ${parseFloat(
                              item.location_available
                            ).toFixed(2)}`}</div>
                            {item?.quantity_discrepancy > 0 ? (
                              <span>
                                discrepancy:{" "}
                                <Tag color="red">
                                  {item?.quantity_discrepancy}
                                </Tag>
                              </span>
                            ) : null}
                          </div>

                          {parseFloat(item.quantity) >
                            parseFloat(item.location_available) &&
                          item.regionalization == "international" ? (
                            <ExclamationCircleOutlined
                              style={{ fontSize: "2.5em", color: "red" }}
                            />
                          ) : null}
                        </div>
                      }
                    />
                  </List.Item>
                );
              }}
            />
          </>
        );
      },
    },
  ];

  return (
    <>
      <div className="maindiv">
        <div className={"generic_container"}>
          <PageHeader
            title={PAGENAME + "s"}
            subTitle={
              <div className={"header"}>
                {/* <Search placeholder="input search text" allowClear={true} onChange={(e)=>{if(!e.target.value &&mainSearch){onSearch(null)}}} onSearch={onSearch} enterButton />  */}
              </div>
            }
            extra={
              <div className={"header"}>
                {/* <AddEditModal headername={PAGENAME} currentItem={currentSelected} 
                        modalMode={modalMode} blueprint={MODAL_BLUEPRINT} apiurl={API_URL}                 
                        onModalClose={(action)=>{
                          setModalMode('add');setCurrentSelected(null)
                          if(action =='reset'){setResetTable(!resetTable)}
                        }}                     
                      /> */}
                <PackageSummary
                  CurrentSelected={currentSelected}
                  currentTab={packageStatus}
                  onCancelmodal={() => {}}
                />
                <PackageQRScanner
                  showButton={true}
                  onCloseModal={() => {
                    setResetTable(!resetTable);
                  }}
                />
                <PackageModal
                  currentItem={currentSelectedRow}
                  onCancelmodal={() => {
                    setCurrentSelectedRow(false);
                    setCurrentSelected(null);
                  }}
                  onCloseModal={(e) => {
                    setCurrentSelectedRow(false);
                    setResetTable(!resetTable);
                    setCurrentSelected(null);
                  }}
                />
                {crudDataCount > 0 ? (
                  <Button
                    type={"primary"}
                    shape={"round"}
                    onClick={() => {
                      dispatch(loadMorePackageData());
                    }}
                    style={{ marginRight: "1em" }}
                  >
                    Load More
                  </Button>
                ) : null}

                <Button
                  onClick={() => {
                    setResetTable(!resetTable);
                  }}
                  className="button"
                >
                  <ReloadOutlined />
                </Button>
              </div>
            }
          >
            <Tabs
              defaultActiveKey="toPack"
              onChange={(e) => {
                setPackageStatus(e);
              }}
            >
              <TabPane tab="Pending" key={"pending"} />
              <TabPane tab="To Pack" key={"toPack"} />
              <TabPane tab="To Ship" key={"toShip"} />
              <TabPane tab="Shipping" key={"shipping"} />
              <TabPane tab="Completed" key={"completed"} />
              <TabPane tab="Cancelled" key={"cancelled"} />
            </Tabs>
          </PageHeader>
          <div className={"content_container"}>
            <PackageTable
              ref={tableRef}
              apiurl={API_URL}
              columns={columns}
              mainSearch={mainSearch}
              resetTable={resetTable}
              ChangedSelected={(selected) => {
                itemSelected(selected);
              }}
              rowClick={(selected) => {
                rowIsSelected(selected);
              }}
              packageStatus={packageStatus}
              allowRowSelection={true}
              rowClassName={(record) => {
                var turnyellow = false;
                // if(item?.new_quantity_to_approve){
                //   if(item.new_quantity_to_approve == true){
                //     turnyellow =true
                //   }
                // }
              }}
            />
          </div>
        </div>
      </div>
      {user.role == "admin" ||
      user.role == "warehouse" ||
      user.role == "manager" ? (
        <Modal
          title={
            mergeto
              ? `merging ${mergeto.current.destination_name} - ${mergeto.current.id}`
              : "merging"
          }
          visible={mergeto}
          onOk={() => {
            mergePackages();
          }}
          onCancel={() => {
            if (!loading) {
              setMergeto(null);
              setMergetoPackage(null);
            }
          }}
          okButtonProps={{
            disabled: !mergetoPackage,
            loading: loading,
          }}
          okText={"Merge"}
        >
          {mergeto && mergeto.options ? (
            <Select
              placeholder="Select a package to merge to"
              value={mergetoPackage}
              style={{ width: "100%" }}
              onChange={(e) => {
                setMergetoPackage(e);
              }}
            >
              {mergeto.options.map((op) => {
                if (mergeto.current.is_direct == op.is_direct) {
                  return <Option value={op.id}>{op.id}</Option>;
                }
              })}
            </Select>
          ) : null}
        </Modal>
      ) : null}
    </>
  );
};

export default Index;
